import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "remixicon/fonts/remixicon.css";

import Subscription from "./pages/Subscription";
import PurchaseSubscription from "./pages/PurchaseSubscription";
import Test from './pages/Test'

import Topbar from "./components/Topbar";
import Sidebar from "./components/Sidebar";
import ProtectRoutes from "./PrivateRoute";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Profile from "./pages/Profile";
import AddService from "./pages/Services/AddService";
import UpdateService from "./pages/Services/UpdateService";

import AppointmentList from "./pages/Appointments/AppointmentList";
import AppointmentDetails from "./pages/Appointments/AppointmentDetails";

import Ratings from "./pages/Ratings/Ratings";

function App() {
  const users = useSelector((state) => state.user.currentUser);
  // console.log(users, 'users');
  return (
    <BrowserRouter>
      {users?.accessToken ? (
        <>
          <Topbar />
          <Sidebar />
        </>
      ) : (
        ""
      )}
      <ToastContainer />

      <Routes>
        <Route element={<ProtectRoutes />}>
          <Route element={<Home />} path="/" exact="true" />
          <Route element={<Profile />} path="/profile/:id" exact="true" />
          <Route element={<AddService />} path="/profile/:id/add-service" exact="true" />
          <Route element={<UpdateService />} path="/profile/:labId/update-service/:id" exact="true" />
          <Route element={<AppointmentList />} path="/appointments/appointment-list" exact="true" />
          <Route element={<AppointmentDetails />} path="/appointments/appointment-details/:id" exact="true" />


          <Route element={<Ratings />} path="/lab-reviews" exact="true" />

          {/* <Route element={<Subscription />} path="/subscription" exact="true" /> */}
          {/* <Route element={<PurchaseSubscription />} path="/purchase-subscription/:id" exact="true" /> */}
          {/* <Route element={<Test />} path="/test" exact="true" /> */}

        </Route>
        <Route path="/login" element={<Login />} exact="true" />
        <Route path="/signup" element={<Signup />} exact="true" />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
